import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getBackgroundRouteKey,
  isBackgroundEnabledRoute,
  pickRandomBackground,
} from "@/backgrounds/karateBackgrounds.js";

/**
 * Fond aléatoire par navigation — une image à la fois, sans répétition immédiate.
 * @returns {{ background: import('@/backgrounds/karateBackgrounds.js').KarateBackground, isAdmin: boolean, fading: boolean }}
 */
export function useRandomKarateBackground() {
  const location = useLocation();
  const routeKey = getBackgroundRouteKey(location.pathname);
  const isAdmin = location.pathname.startsWith("/admin");
  const enabled = isBackgroundEnabledRoute(location.pathname);

  const [background, setBackground] = useState(() => pickRandomBackground());
  const [fading, setFading] = useState(false);
  const lastIdRef = useRef(background.id);
  const lastRouteRef = useRef(routeKey);

  useEffect(() => {
    if (!enabled) return;
    if (lastRouteRef.current === routeKey) return;

    lastRouteRef.current = routeKey;
    setFading(true);

    const timer = window.setTimeout(() => {
      const next = pickRandomBackground(lastIdRef.current);
      lastIdRef.current = next.id;
      setBackground(next);
      setFading(false);
    }, 180);

    return () => window.clearTimeout(timer);
  }, [routeKey, enabled]);

  return { background, isAdmin, fading, enabled };
}
